import { render, staticRenderFns } from "./NewComposerThreads.vue?vue&type=template&id=4d09d580&"
import script from "./NewComposerThreads.vue?vue&type=script&lang=js&"
export * from "./NewComposerThreads.vue?vue&type=script&lang=js&"
import style0 from "./NewComposerThreads.vue?vue&type=style&index=0&id=4d09d580&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports